"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledBoldText = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("../../assets/styles/config");
exports.StyledBoldText = styled_components_1.default.p `
  font: bold ${config_1.fontSizes.big} ${config_1.fontFamilies.primary};
`;
